import { render, staticRenderFns } from "./SeminarEntryBulkUpdate.vue?vue&type=template&id=60d19416"
import script from "./SeminarEntryBulkUpdate.vue?vue&type=script&lang=js"
export * from "./SeminarEntryBulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports